import { useRouter } from 'next/router';
import RonsTipsCategoryBar from './RonsTipsCategoryBar';
import MarketCategoryBar from './MarketCategoryBar';
import CommunityCategoryBar from './CommunityCategoryBar';

const CategorySubNavbar = () => {
  const router = useRouter();
  if (router?.pathname?.includes('/rons-tips')) return <RonsTipsCategoryBar />;
  else if (router?.pathname?.includes('/market')) return <MarketCategoryBar />;
  else return <CommunityCategoryBar />;
};

export default CategorySubNavbar;
